









import { defineComponent, computed } from '@vue/composition-api';
import { LoremIpsum } from 'lorem-ipsum';

import useOverlay from '@/components/composers/useOverlay';

const MapOverlay: object = defineComponent({
  name: 'MapOverlay',
  setup() {
    const title = computed(() => {
      const lorem = new LoremIpsum();
      return lorem.generateWords(3);
    });
    const paragraph = computed(() => {
      const lorem = new LoremIpsum();
      let content = '';
      for (let i = 0; i < 20; i += 1) {
        content += `<p>${lorem.generateParagraphs(1)}</p>`;
      }
      return content;
    });
    return {
      title,
      paragraph,
      ...useOverlay(),
    };
  },
});
export default MapOverlay;
